import { render } from "./LectorView.vue?vue&type=template&id=0ca4e55f"
import script from "./LectorView.vue?vue&type=script&lang=js"
export * from "./LectorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__